import { useEffect, useState } from 'react';
import { Routes } from 'router/routes';

import type { NavigateFunction } from 'react-router-dom';

export const useBlockedCountdown = (
  blocked: boolean,
  navigate: NavigateFunction,
) => {
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (!blocked) return;
    setShowModal(true);
    setCountdown(30);
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.close();
          timeoutId = setTimeout(() => {
            navigate(Routes.overviewDashboard, { replace: true });
          }, 500);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      clearInterval(interval);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [blocked, navigate]);

  return {
    countdown,
    showModal,
    dismissModal: () => setShowModal(false),
  };
};
